<template>
	<Popup
		v-model="selfDisplay"
		title="赠送积分"
		confirmBtnText="新增"
		@confirmClick="handleAddClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>用户账号</span>
				<el-input v-model="code" placeholder="用户账号"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="codeTip"><i class="b_icon"></i>请输入用户账号</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>积分</span>
				<el-input v-model="integral" placeholder="积分"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="integralTip"><i class="b_icon"></i>请输入整数</template></div>
			
			<div class="base_form_row">
				<span class="b_label">备注</span>
				<el-input v-model="remark" placeholder="备注"></el-input>
			</div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../../../api/index.js';
	
	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				
				code: '',
				integral: '',
				remark: '',
				codeTip: false,
				integralTip: false
			}
		},
		methods: {
			// 点击新增
			handleAddClick() {
				if (!this.code) {
					this.codeTip = true;
					return false;
				} else {
					this.codeTip = false;
				}
				if (!this.positiveReg.test(this.integral)) {
					this.integralTip = true;
					return false;
				} else {
					this.integralTip = false;
				}
				this.add();
			},
			// 新增
			add() {
				const that = this;
				that.loading = true;
				let requestData = {
					yiCode: that.code,
					pointsValue: that.integral,
					remark: that.remark
				};
				Api.addIAssistantIntegralRecord(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (!newVal) {
					this.loading = false;
					this.code = '';
					this.integral = '';
					this.remark = '';
					this.codeTip = false;
					this.integralTip = false;
				}
			}
		}
	}
</script>

<style>
</style>
